export const environment = {
  production: false,
  environment: 'dev',
  useAppCheckDebugToken: false, // Prevent debug tokens in deployed dev
  firebase: {
    apiKey: "AIzaSyAGt-0sDdHnWQz1t6LEK1yYyFNoSU_BO44",
    authDomain: "up-forsale-studio-dev.firebaseapp.com",
    projectId: "up-forsale-studio-dev",
    storageBucket: "up-forsale-studio-dev.firebasestorage.app",
    messagingSenderId: "1046141018774",
    appId: "1:1046141018774:web:17c2360ef86c9e9aedd8b7",
    measurementId: "G-V8V3VWFWQL"
  },
  appCheck: {
    // reCAPTCHA Enterprise site key for App Check
    siteKey: "6LehEjwsAAAAAEcbO2SeC90XcRK7rpbqEgOENuKg"
  },
  api: {
    baseUrl: "https://australia-southeast1-up-forsale-data-dev.cloudfunctions.net"
  },
  loadBalancer: {
    // HTTPS Load Balancer URLs for Cloud Armor protection
    // Using domain (requires DNS configuration and SSL certificate provisioning)
    studioDev: "https://australia-southeast1-up-forsale-studio-dev.cloudfunctions.net"
  },
  viewer: {
    // Viewer app hosting URL (for generating shareable map links)
    // Using custom domain: dev.up.forsale
    url: "https://dev.up.forsale"
  }
};

